export default {

    // 处理
    trim:function(value:any){
        value = value || '';
        if (typeof value !== 'string')  value +='';
        return value.replace(/^\s*|\s*$/,'');
    }

}